/**
 * The main api service
 */
import http from "@util/http";
import { xxcrm } from "../req";

/**
 * 合同列表
 */
export async function queryContractList(params) {
  return http.get(xxcrm.CONTRACT_LIST, params);
}

/**
 * 获取合同类型
 */
export async function queryContractType() {
  return http.get(xxcrm.CONTRACT_TYPE);
}

/**
 * 获取操作日志
 */
export async function queryContractLog(uuid) {
  return http.get(xxcrm.CONTRACT_LOG, { contractUuid: uuid });
}

/**
 * 添加合同
 */
export async function querySaveContract(params) {
  return http.post(xxcrm.CONTRACT_SAVE, params);
}

/**
 * 批量添加合同
 */
export async function queryBatchSaveContract(params) {
  return http.post(xxcrm.CONTRACT_BATCHSAVE, params);
}

/**
 * 删除合同
 */
export async function queryDeleteContract(uuid) {
  return http.get(xxcrm.CONTRACT_DELETE, { uuids: uuid });
}

/**
 * 角色删除
 */
export async function queryDeleteRole(uuid) {
  return http.get(xxcrm.CONTRACT_DELETE, { uuid });
}

/**
 * 使用合同
 */
export async function queryUseContract(params) {
  return http.post(xxcrm.CONTRACT_USE, params);
}

/**
 * 分配合同
 */
export async function queryAllotContract(params) {
  return http.post(xxcrm.CONTRACT_ALLOT, params);
}

/**
 * 转移合同
 */
export async function queryTransferContract(params) {
  return http.post(xxcrm.CONTRACT_TRANSFER, params);
}

/**
 * 转移合同确认
 */

export async function queryTransferContractConfirm(params) {
  return http.post(xxcrm.CONTRACT_TRANSFER_CONFIRM, params);
}

/**
 * 转移合同拒绝
 */
export async function queryTransferContractRefuse(params) {
  return http.post(xxcrm.CONTRACT_TRANSFER_REFUSE, params);
}

/**
 * 作废合同
 */
export async function queryInvalidContract(params) {
  return http.post(xxcrm.CONTRACT_INVALID, params);
}

/**
 * 遗失合同
 */
export async function queryLostContract(params) {
  return http.post(xxcrm.CONTRACT_LOST, params);
}

/**
 * 恢复合同
 */
export async function queryRestoreContract(uuids) {
  return http.post(xxcrm.CONTRACT_RESTORE, { uuids });
}

/**
 * 回收合同
 */
export async function queryRecycleContract(uuids) {
  return http.post(xxcrm.CONTRACT_RECYCLE, { uuids });
}

/**
 * 合同申请
 */
export async function querySaveApplyContract(params) {
  return http.post(xxcrm.CONTRACT_APPLY_SAVE, params);
}

/**
 * 合同申请列表
 */
export async function queryApplyContractList(params) {
  return http.get(xxcrm.CONTRACT_APPLY_LIST, params);
}

/**
 * 分配合同申请的合同
 */
export async function queryAllotApplyContract(params) {
  return http.post(xxcrm.CONTRACT_APPLY_ALLOT, params);
}

/**
 * 同意合同申请
 */
export async function queryCheckContract(params) {
  return http.post(xxcrm.CONTRACT_CHECK, params);
}

/**
 * 拒绝合同申请
 */
export async function queryRefuseContract(params) {
  return http.post(xxcrm.CONTRACT_REFUSE, params);
}

/**
 * 导出合同
 */
export async function queryExportContract(params) {
  http.download(xxcrm.CONTRACT_EXPORT, params, '合同导出.xlsx');
}



// WEBPACK FOOTER //
// ./src/api/xxcrm/contract.js